<script setup lang="ts">
import ExpressIcon from '../../icons/ExpressIcon.vue';
</script>
<template>
	<div
		class="express-badge py-xxs lg:h-7xl px-xs lg:pl-xs lg:pr-sm lg:rounded-small h-fit flex items-center bg-blue-600 rounded"
		data-testid="express-badge"
	>
		<ExpressIcon
			weight="fill"
			class="fill-warning-300"
			:width="'12'"
			:height="'12'"
		/>
		<p class="text-xs tracking-[-0.24px] italic font-bold text-white">
			Express
		</p>
	</div>
</template>
